/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';
import * as Materials from '../../utils/materials';

/**
 * Should contain data that will be used for output or computing data for the next step in the wizard.
 */
export default class NextStepsResults extends EmberObject {
  filter = null;
  tolerances = null;
  specificationsInput = null;
  componentsInput = null;
  toleranceInput = null;
  opAmpSource = null;
  @computed('tolerances') get magnitudeDb() {
    return this.tolerances.magnitudeDb;
  }

  @computed('tolerances') get magnitudeVV() {
    return this.tolerances.magnitudeVV;
  }

  @computed('tolerances') get phaseDegrees() {
    return this.tolerances.phaseDegrees;
  }

  @computed('tolerances') get phaseRadians() {
    return this.tolerances.phaseRadians;
  }

  @computed('tolerances') get groupDelay() {
    return this.tolerances.groupDelay;
  }

  @computed('tolerances') get phaseDelay() {
    return this.tolerances.phaseDelay;
  }

  @computed('tolerances') get stepResponse() {
    return this.tolerances.stepResponse;
  }

  @computed('tolerances') get inputImpedanceMagnitude() {
    return this.tolerances.inputImpedanceMagnitude;
  }

  @computed('tolerances') get inputImpedancePhase() {
    return this.tolerances.inputImpedancePhase;
  }

  @computed('tolerances') get detailsOfCircuits() {
    return this.tolerances.detailsOfCircuits;
  }

  @computed('tolerances') get detailsOfStages() {
    console.time('detailsOfStages');
    var result = this.tolerances.detailsOfStages;
    console.timeEnd('detailsOfStages');
    return result;
  }

  @computed('tolerances') get needReferenceStage() {
    return this.tolerances.needReferenceStage;
  }

  @computed('tolerances') get noise() {
    return this.tolerances.noise;
  }

  @computed('tolerances') get voltageRange() {
    return this.tolerances.voltageRange;
  }

  @computed('tolerances') get power() {
    return this.tolerances.power;
  }

  @computed('filter', 'specificationsInput', 'componentsInput', 'toleranceInput', 'tolerances') get billOfMaterials() {
    let filterType = this.filter.name;
    let specificationsInput = this.specificationsInput;
    let vsMinus = this.componentsInput.vsMinus;
    let needReferenceStage = this.needReferenceStage;
    let toleranceInput = this.toleranceInput;
    let stageDetails = this.tolerances.detailsOfStages;
    let circuitDetails = this.tolerances.detailsOfCircuits;
    let opAmpSource = this.opAmpSource;
    return Materials.billOfMaterials(
      filterType,
      specificationsInput,
      vsMinus,
      stageDetails,
      circuitDetails,
      toleranceInput,
      needReferenceStage,
      opAmpSource,
    );
  }

  @computed('componentsInput', 'toleranceInput', 'tolerances') get evalBoardData() {
    let vsMinus = this.componentsInput.vsMinus;
    let needReferenceStage = this.needReferenceStage;
    let toleranceInput = this.toleranceInput;
    let stageDetails = this.tolerances.detailsOfStages;
    let circuitDetails = this.tolerances.detailsOfCircuits;
    let opAmpSource = this.opAmpSource;
    return Materials.orderEvalBoard(
      vsMinus,
      stageDetails,
      circuitDetails,
      toleranceInput,
      needReferenceStage,
      opAmpSource,
    );
  }

  @computed('tolerances') get orderSamplesData() {
    let stageDetails = this.tolerances.detailsOfStages;
    let opAmpSource = this.opAmpSource;
    return Materials.orderSamples(stageDetails, opAmpSource);
  }
}
